import { Box, Grid, Paper, Skeleton, useTheme } from '@mui/material'
import React from 'react'

interface PortfolioValueSkeletonProps {
  cardCount?: number
}

export default function PortfolioValueSkeleton({ cardCount = 3 }: PortfolioValueSkeletonProps): React.ReactElement {
  const theme = useTheme()

  return (
    <Grid container spacing={3}>
      {Array.from({ length: cardCount }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={`skeleton-card-${index}`}>
          <Paper
            elevation={0}
            sx={{
              padding: 3,
              backgroundColor: theme.palette.grey[50],
              borderRadius: '12px',
              border: `1px solid ${theme.palette.grey[300]}`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              minHeight: 120,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: 2,
                gap: 1,
              }}
            >
              <Skeleton variant="circular" width={24} height={24} />
              <Skeleton variant="text" width={60} height={24} />
            </Box>

            <Skeleton variant="text" width={140} height={40} sx={{ fontSize: '2rem' }} />
          </Paper>
        </Grid>
      ))}
    </Grid>
  )
}
